angular.module("stipulaLo.components", [])
    .component("stipulaLo", {
        templateUrl: "ng/components/stipulaLo/stipulaLo.view.html",
        bindings: {
            exportValue: '&',
            isLo: '<'
        },
        controller: StipulaLocazioneOperativaCtrl,
        controllerAs: "stipulaLoCtrl"
    })


function StipulaLocazioneOperativaCtrl(
    $scope
) {
    var self = this;
    self.$onInit = function () {
        self.model = {
            dataStipula: "",
            dataIncasso: ""

        };
        self.validationObj = {
            documentDate: {
                disabledDays: [0],
                disabledDates: [
                    "01-01",
                    "06-01",
                    "25-04",
                    "01-05",
                    "02-06",
                    "15-08",
                    "01-11",
                    "08-12",
                    "25-12",
                    "26-12"
                ]
            }
        };
    }

    self.setValueModel = function (tipo, value) {
        self.model[tipo] = value;
        if (tipo == 'dataIncasso') {
            if (!!self.model.dataIncasso) {

                self.setImportoObbligatorio = true;
            } else {
                self.setImportoObbligatorio = false;
            }
        }
        if (tipo == 'importoIncasso') {
            if (!!self.model.importoIncasso) {

                self.setDataIncassoObbligatorio = true;
            } else {
                self.setDataIncassoObbligatorio = false;
            }
        }
    }

    self.stipula = function () {
        self.exportValue({ model: self.model })
    }

    self.enebleButtonConfirmStipula = function () {
        var test = true;

        test = test && !!self.model.dataStipula

        if (!self.isLo && (self.setImportoObbligatorio || self.setDataIncassoObbligatorio)) {
            test = test &&
                !!self.model.dataIncasso &&
                !!self.model.importoIncasso
        }

        return test;
    }
}